import { ContactSuccessPage } from "../../../components/sagrada/pages/contact/ContactSuccessPage";

export default ContactSuccessPage;
